import { Badge, Group, Loader, Text } from "@mantine/core";
import { useWebSocket } from "@/hooks/useWebSocket";

export function ScrapeStatus() {
  const { status, isConnected } = useWebSocket();

  if (!isConnected) {
    return (
      <Badge variant="filled" color="#0f3460" size="lg" radius="xl">
        <Text size="sm" c="dimmed">
          Disconnected
        </Text>
      </Badge>
    );
  }

  if (status.is_running) {
    return (
      <Badge variant="filled" color="yellow" size="lg" radius="xl">
        <Group gap={6}>
          <Loader size={12} color="dark" />
          <Text size="sm" c="dark">
            Scraping...
          </Text>
        </Group>
      </Badge>
    );
  }

  if (status.next_run_seconds !== undefined && status.next_run_seconds !== null) {
    const mins = Math.floor(status.next_run_seconds / 60);
    const secs = status.next_run_seconds % 60;
    return (
      <Badge variant="filled" color="#0f3460" size="lg" radius="xl">
        <Group gap={6}>
          <span
            style={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: isConnected ? "#4caf50" : "#888888",
            }}
          />
          <Text size="sm">
            Next: {mins}:{secs.toString().padStart(2, "0")}
          </Text>
        </Group>
      </Badge>
    );
  }

  return (
    <Badge variant="filled" color="#0f3460" size="lg" radius="xl">
      <Text size="sm" c="dimmed">
        Scheduler off
      </Text>
    </Badge>
  );
}
